import { useState, useContext } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Sidebar from "../../components/Sidebar";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Form from "react-bootstrap/Form";
import "react-datepicker/dist/react-datepicker.css";
import { useForm } from "react-hook-form";
import Loader from "../../components/Loader";
import axios from "axios";
import { toast } from "react-toastify";
import { ProfileContext } from "../../context/ProfileContext";
import { BASE_URL, UPDATE_TEST } from "../../API";
import { diagnosticCategories } from "../../utils/helper";

function ViewDiagnosticTest() {
  const { headers, getTests } = useContext(ProfileContext)
  const { state } = useLocation();
  const navigate = useNavigate();
  const [viewMode, setViewMode] = useState("view");
  const [isLoading, setIsLoading] = useState(false);

  const { register, handleSubmit, formState: { errors } } = useForm({ defaultValues: state });


  const onSubmit = async (data) => {
    setIsLoading(true);
    try {
      const response = await axios.patch(BASE_URL + UPDATE_TEST, data, { headers });

      if (response.data.code === 200 && response.data.status === true) {
        toast.success(response.data.message);
        getTests();
        navigate("/diagnostic-test-management");
      } else {
        toast.error(response.data.message || "Something went wrong");
      }
    } 
    catch (error) {
      const errorMessage = error.response?.data?.error || "An error occurred. Please try again.";
      toast.error(errorMessage);
    } 
    finally {setIsLoading(false)}
  };

  return (
    <>
      <Loader isLoading={isLoading} />

      <div className="container-fluid">
        <Header />
        <div className="row">
          <Sidebar />
          <div className="col-9 main-dash-left">
            <section className="back-dashboard-sec comn-dashboard-page">
              <div className="cstm_bredcrumb_outer">
                <Breadcrumb className="cstm_bredcrumb" listProps={{ className: "breadcrumb-custom-separator" }}>
                  <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/diagnostic-test-management" }}>Diagnostic Test Management</Breadcrumb.Item>
                  <Breadcrumb.Item active>{viewMode === "view" ? "View" : "Edit"} Details</Breadcrumb.Item>
                </Breadcrumb>
              </div>

              <div className="patient_referral_form">
                <div className="d-flex justify-content-between align-items-center">
                  <h5 className="comm_inner_sub_heading mb-0">{viewMode === "view" ? "View" : "Edit"} Center Details</h5>
                  <button type="button" className="main-outline-btn" onClick={() => setViewMode(viewMode === "view" ? "edit" : "view")}>
                    {viewMode === "view" ? "Edit" : "Cancel Edit"}
                  </button>
                </div>

                <div className="comm_border_box mt-3">
                  <Form className="comm_form" onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                      <Col md={6}>
                        <Form.Group className="comn-class-inputs">
                          <Form.Label>Test Name</Form.Label>
                          <Form.Control type="text" placeholder="Enter Center Name" disabled={viewMode === "view"}
                            {...register("test_name", { required: "Please enter test name" })}
                          />
                          {errors.center_name && (<span className="error">{errors.center_name.message}</span>)}
                        </Form.Group>
                      </Col>


                      <Col md={6}>
                        <Form.Group className="comn-class-inputs">
                          <Form.Label>Category</Form.Label>
                          <Form.Select {...register("category", { required: "Please select category." })} disabled={viewMode === "view"}>
                            <option value="">Select </option>
                            {diagnosticCategories.map((cate, index) => (<option key={index} value={cate.value}>{cate.label}</option>))}
                          </Form.Select>
                          {errors.category && (<span className="error">{errors.category.message}</span>)}
                        </Form.Group>
                      </Col>
                    </Row>

                    {viewMode === "edit" && (
                      <div className="modal_pair_btns patient_referral_btns mt-3">
                        <button className="main-btn" type="submit">Submit</button>
                        <button type="button" className="main-outline-btn" onClick={() => navigate("/diagnostic-test-management")}>Discard Changes</button>
                      </div>
                    )}
                  </Form>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}

export default ViewDiagnosticTest;
